import classNames from 'classnames'
import './toast.scoped.sass'
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'
import { Button } from '../Button/Button'
import { ReactComponent as InfoIcon } from '@/assets/icons/info-heroicon.svg'
import { ReactComponent as SuccessIcon } from '@/assets/icons/success-heroicon.svg'
import { ReactComponent as WarningIcon } from '@/assets/icons/warning-heroicon.svg'
import { ReactComponent as ErrorIcon } from '@/assets/icons/error-heroicon.svg'

export function Toast (props) {
  const { title, message, onClick, buttonText, type, hide, mobileTapText } = props
  return (<div id={props.id} className={classNames('toast', {
    success: type === 'success',
    info: type === 'info',
    error: type === 'error',
    warning: type === 'warning'
  })}>
    <div className='icon'>
      {type === 'info' && <InfoIcon/>}
      {type === 'success' && <SuccessIcon/>}
      {type === 'error' && <ErrorIcon/>}
      {type === 'warning' && <WarningIcon/>}
    </div>
    <div className='main-content'>
      <div className='main-content-title'>
        {title}
      </div>
      {message && <div className='main-content-subtitle'>
        {message}
      </div>}
      {onClick && <div className='main-content-action'>
        <Button content={buttonText} size='small' type='secondary' click={(e) => {
          hide && hide()
          onClick(e)
        }}/>
      </div> }
      {onClick && mobileTapText && <div className='main-content-action-mobile' onClick={(e) => {
        hide && hide()
        onClick(e)
      }}>
        {mobileTapText}
        </div>}
    </div>
    <div className='close'>
      <CrossIcon className='cross-icon' onClick={hide}/>
    </div>
    
  </div>)
}
